<template>
	<div class="meetings content">
		<component :is="href('/interactions/meetings/details').content" />
		<div v-show="showDetails">
			<form v-show="showForm" ref="form">
				<label><font-awesome-icon icon="user"/> {{ href('/interactions/meetings/details').meta.name }}</label>
				<input type="text" name="name" v-model="name">

				<label><font-awesome-icon icon="calendar-alt"/> {{ href('/interactions/meetings/details').meta.date }}</label>
				<div class="date">
					<v-date-picker
						v-model="date"
						tint-color="#392b6e"
						:show-day-popover="false"
						show-caps
					/>
				</div>
				<label><font-awesome-icon icon="video" /> {{ href("/interactions/meetings/details").meta.meeting }}</label>
				<label class="radio">
					<input type="radio" name="meeting" value="Zoom" v-model="meeting" />
					<span class="indicator"></span>
					<span class="label">Zoom</span>
				</label>
				<label class="radio">
					<input type="radio" name="meeting" value="Skype" v-model="meeting" />
					<span class="indicator"></span>
					<span class="label">Skype</span>
				</label>
				<label class="radio">
					<input type="radio" name="meeting" value="Google Meet" v-model="meeting" />
					<span class="indicator"></span>
					<span class="label">Google Meet</span>
				</label>
				<label class="radio">
					<input type="radio" name="meeting" value="Viber" v-model="meeting" />
					<span class="indicator"></span>
					<span class="label">Viber</span>
				</label>
				<input type="hidden" name="to" value="info@whitebox.pro">
				<input type="hidden" name="subject" :value="href('/interactions/meetings/details').meta.subject">
				<input type="hidden" name="from" :value="email">
				<input type="hidden" name="phone" :value="phone">
				<input type="hidden" name="date" :value="date">
				<input type="hidden" name="context" value="demo-meetings">
				<input type="hidden" name="template-html" :value="hres('template')">
				<div class="actions">
					<button ref="submit" type="submit"> {{ href("/interactions/meetings/details").meta.request }}</button>
				</div>
			</form>
			<div v-show="!showForm" class="condition">
				<component :is="href('/interactions/meetings/info').content" />
				<h3><font-awesome-icon icon="tasks"/> {{ href('/interactions/meetings/info').meta.interactions }} {{ treshold }}%</h3>
				<span class="progress">{{ progress }}% {{ href('/interactions/meetings/info').meta.completed }}</span>
			</div>
		</div>
	</div>
</template>

<script>
import hreflang from '@/lib/hreflang'
import { mapGetters, mapState } from "vuex";
import moment from 'moment'

export default {
	name: 'MeetingsInteraction',
	mixins: [ hreflang ],
	data() {
		return {
			ring: false,
			treshold: 50,
			date: moment().add(1, 'day').toDate(),
			meeting: '',
			name: '',
			email: '',
			phone: '',
		}
	},
	computed: {
		...mapGetters("demo", ["interactionsTotal", "interactionsCompleted"]),
		...mapState({
			passport: state => state.demo.passport,
		}),
		progress() {
			return Math.round(this.interactionsCompleted / this.interactionsTotal * 100)
		},
		showForm() {
			return this.progress > this.treshold && this.email
		}
	},
	props: {
		showDetails: Boolean,
	},
	watch: {
		passport() {
			this.initPassport()
		}
	},
	methods: {
		initPassport() {
			if (this.passport && this.passport.identities) {
				let email = this.passport.identities.find(identity => identity.id == 'email')
				if (email && !this.email) {
					this.email = email.value
				}
				let phone = this.passport.identities.find(identity => identity.name == 'e164')
				if (phone && !this.phone) {
					this.phone = phone.value
				}
				let name = this.passport.identities.find(identity => identity.id == 'name')
				if (name && !this.name) {
					this.name = name.value
				}
			}
		},
		initMail() {
			window.whitebox.init('mail', mail => {
				if (mail) {
					mail.on('mail.send', () => {
						this.send = true
					}, this)
					mail.service.ajaxForm(this.$refs.form)
				}
			})
		}
	},
	mounted() {
		this.initMail()
	},
	created() {
		this.document(require('documents/en/interactions/meetings-details.md'), 'en')
		this.document(require('documents/en/interactions/meetings-info.md'), 'en')
		this.resource('template', require('documents/en/interactions/meetings-template.html'), 'en')
	},
}
</script>

<style scoped lang="less">
@import url('~whitebox-presentation/src/assets/variables.less');
@import url('~whitebox-presentation/src/assets/mixins.less');
@import url('~whitebox-presentation/src/assets/components/date-picker.less');

h3 {
	font-size: @font-size-s;
	margin-top: @gap * 2;
	color: @gray-50;
	font-weight: @normal;
	margin-bottom: 0;
}

.content {
	padding: 0;
}

.progress {
	.count();
}

.condition {
	margin-top: @gap * 2;
}

/deep/ .date {
	.date-picker();
	.date-picker-flat();
	margin-bottom: @gap * 2;
}

.radio {
	margin-right: @gap;
}

.actions {
	margin-top: @gap * 2;
}

form {
	margin-top: @gap * 2;
}

input,
.input {
	width: 60%;
	margin-right: @gap * 4;
}

.whitebox-mail-success {
	display: none;
}

</style>
